// extracted by mini-css-extract-plugin
module.exports = {"component":"PopoverNone_component__29jND","inner":"PopoverNone_inner__1CMdK","footer":"PopoverNone_footer__4kgvw"};